import { useEffect, useState } from 'react'
import { LayoutNarrowTwo, LayoutTwo } from '../../Layout/CommonStyle'
import JobClassList from './ClassList'
import { axiosGet } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import { Result } from '../../../models/Dto/Result'
import { UserGroup } from '../../../models/UserGroup'
import Main from './Main'

function AdminJobClass() {
  const [groups, setGroups] = useState<UserGroup[]>([])
  const [selectedGroup, setSelectedGroup] = useState<UserGroup | undefined>(
    undefined
  )

  useEffect(() => {
    loadGroups()
  }, [])

  const loadGroups = async () => {
    const result = await axiosGet('/api/user/group')

    setGroups(result.data)

    console.log('loadGroups', result.data)
    if (result.data.length > 0) {
      setSelectedGroup(result.data[0])
    }
  }

  return (
    <LayoutNarrowTwo>
      <JobClassList
        groups={groups}
        setGroups={setGroups}
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
      />
      <Main
        group={selectedGroup}
        setGroup={setSelectedGroup}
        groups={groups}
        setGroups={setGroups}
      />
    </LayoutNarrowTwo>
  )
}

export default AdminJobClass
